export default () => `
  {
    currentStore {
      currency {
        code
        symbol
        thousandsSeparator
        decimalMark
        symbolFirst
      }
      sizeSystem
      customerServiceEmail
      customerServicePhone
      returnsInformation
      shipping {
        cost
        threshold
      }
      shippingInformation
    }
  }
`
